import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs, bounds } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
import Sticky from "../../scripts/components/Sticky"
import store from "../store"
import { ScrollTrigger } from "../libraries/gsap/index"

export default class StoryImage extends Component {
  constructor(obj) {
    super(obj)

    this.animate()
    // gsap.set(this.el, { autoAlpha: 0 })
  }

  animate() {
    const img = qs(".img", this.el)

    gsap.to(img, {
      width: "100%",
      height: "100%",
      duration: 1.5,
      scrollTrigger: {
        trigger: qs(".image-wrapper", this.el),
        start: "top bottom",
      },
    })

    // gsap.set(this.el, { autoAlpha: 1 })
  }
}
